<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="media-manager-title-bar modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Media Manager</h1>
                <div @click="$modal.hide('media-manager')">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="p-5 mx-auto w-full">
                <div class="alert blue max-w-5xl">
                    Drag media to reorder or hover over an item and click the 'X' to delete it from the media album.
                </div>
                <div class="mt-4 flex items-center gap-x-6 gap-y-4">
                    <draggable
                        class="flex flex-wrap"
                        v-model="sortableMedia"
                        @end="saveSortOrders(false)">
    	                    <div v-for="(item, itemIndex) in sortableMedia" :key="itemIndex" class="group relative draggable-item">
    	                    	<img class="w-28 h-28" :src="item.is_image ? item.view_url : '/img/video.png'" />
    	                    	<div v-if="item.view_url != '/img/temp/building-sample.jpg'" @click="deleteMediaConfirmation(item)" class="hidden bg-white rounded-full absolute -top-2 right-0 group-hover:flex cursor-pointer">
    	                    		<inline-svg name="x"></inline-svg>
    	                    	</div>
    	                	</div>
                    </draggable>
                </div>
            </div>
            <div class="p-4 flex items-center justify-between bg-gray-100">
                <button v-if="showUploadButton && $gate.can('create', 'document')" @click="showDocumentUpload" type="button" class="btn btn-small btn-green flex items-center">
                    <inline-svg name="upload" classes="w-4 h-4 text-white fill-current"></inline-svg>
                    <span class="ml-2">Upload New Media</span>
                </button>
                <div class="text-right">
                    <button class="btn btn-secondary mr-2" @click.prevent="$modal.hide('media-manager')">Close</button>
                    <button class="btn btn-green" @click.prevent="saveSortOrders">
                        <span v-if="loading">
                            <inline-svg name="loading-button"></inline-svg>                                
                        </span>
                        <span v-if="! loading">Save</span>
                    </button>
                </div>
            </div>
		</div>
		<notifications classes="notification" position="bottom right"></notifications>

        <modal name="media-upload" width="60%" height="auto" :click-to-close="false">
            <upload-document
                label="Upload Media"
                :allowed-categories="['Photo', 'Extras']"
                :documentable-id="documentableId"
                :documentable-type="documentableType">
            </upload-document>
        </modal>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import draggable from "vuedraggable";

	export default {
		props: {
			media: {
				type: [Array, Object],
				required: true
			},

            documentableId: {
                type: Number,
                required: true
            },

            documentableType: {
                type: String,
                required: true
            },

            showUploadButton: {
                type: Boolean,
                default: true
            },
		},

		components: {
			draggable
		},

		data() {
			return {
				galleryMedida: this.media,
				loading: false
			}
		},

		computed: {
			...mapState(['documents']),

		    sortableMedia: {
		      get() {
		        return _.sortBy(this.galleryMedida, 'sort_order');
		      },
		      
		      set(newValues) {
		      	this.galleryMedida = newValues;
		      }
		    },
		},

		methods: {
            showDocumentUpload() {
                this.$modal.show('media-upload');
            },

			saveSortOrders(closeModal = true) {
                _.each(this.galleryMedida, (item, index) => {
	                item.sort_order = index + 1;
                });

                axios.patch('/api/documents', this.galleryMedida)
                    .then((response) => {
                    	if (closeModal) {
                    		this.$modal.hide('media-manager');
                    	}

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Sort Orders Updated'
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
			},

			deleteMediaConfirmation(media) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this media?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteDocument(media);
                    }
                });
            },

            deleteDocument(media) {
                axios.delete('/documents/' + media.id)
                    .then((response) => {
		                this.sortableMedia = _.reject(this.sortableMedia, (item) => {
		                    return item.view_url == media.view_url;
		                });

                        this.$eventHub.$emit('remove-from-gallery', media.view_url);

                        if (this.sortableMedia.length == 0) {
                        	this.$modal.hide('media-manager');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },
		},
	}
</script>